/* eslint-disable prettier/prettier */
import colors from "constants/color";
import styled from "styled-components";
import {
  TextField,
  Radio,
  Checkbox,
  Select,
  TableCell,
  TableRow,
} from "@mui/material";
import materialUI from "material-UI";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const BodyContainer = styled.div`
  width: 100%;
  margin-top: 16px;
`;

export const TableContainerStyled = styled.div`
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 24px;
  padding-bottom: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);

  &::-webkit-scrollbar-thumb {
    background-color: #a3a3a6;
    border-radius: 8px;
  }
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
  }
`;

export const Row = styled.div`
  width: 100%;
  gap: 12px;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-top: 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.h1`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  color: #333333;
`;

export const TitleTableHeader = styled.h1`
  font-family: Inter;
  opacity: 0.5;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  color: #333333;
`;

export const DifContainer: any = styled.div`
  display: flex;
  background-color: ${(props: any) =>
    props.verifyDiff ? "#ffd5d5" : "#ebfff0"};
  border: 1px solid
    ${(props: any) => (props.verifyDiff ? "#f43636" : "#4caf50")};
  border-radius: 8px;
  padding: 8px;
`;

export const DifContainerValue = styled.div`
  display: flex;
  background-color: #f2f4f8;
  border: 1px solid #b3b5b8;
  border-radius: 8px;
  padding: 8px;
`;

export const StyledTextField = styled(materialUI.TextField)`
  margin-top: 4px;
  width: 100%;
  label {
    display: none;
  }

  .MuiInputBase-root {
    border-radius: 8px;
    height: 44px;
    margin: 0;
    padding-top: 2px;
  }
  .MuiInputBase-input {
    height: 44px;
  }
  .MuiTypography-root {
    padding-top: 1px;
  }
  .MuiOutlinedInput-input {
    padding: 0 12px;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 4px;
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: #f2f4f8; /* Mantemos essa linha para consistência */
    input {
      color: ${colors.grey1};
    }
  }
  .MuiInputBase-root.Mui-disabled {
    background-color: #f2f4f8 !important; /* Define a cor de fundo vermelha para campos desativados */
    input {
      color: ${colors.grey1} !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const StyledTextFieldData = styled(TextField)<{ active?: boolean }>`
  margin-top: 4px;
  min-width: 80px;
  label {
    display: none;
  }

  .MuiInputBase-root {
    border-radius: 8px;
    height: 44px;
    margin: 0;
    width: 80px;
    padding-top: 2px;
    padding-right: 0;
  }
  .MuiInputBase-input {
    height: 44px;
  }
  .MuiTypography-root {
    padding-top: 1px;
  }
  .MuiOutlinedInput-input {
    padding: 0 6px 0 12px;
  }
  .MuiButtonBase-root {
    padding: 0;
    color: ${({ active }) => (active ? "#A3A3A6" : "transparent")};
    :disabled {
      color: transparent;
    }
  }

  .MuiIconButton-edgeEnd {
    width: 82px;
    height: 48px;
    position: absolute;
    bottom: -2px;
    left: -1px;
    border-radius: 8px;
    padding: 0;
  }
  &.input-disabled {
    background-color: #f2f4f8; /* Mantemos essa linha para consistência */
    input {
      color: ${colors.grey1};
    }
  }
  .MuiInputBase-root.Mui-disabled {
    background-color: #f2f4f8 !important; /* Define a cor de fundo vermelha para campos desativados */
    input {
      color: ${colors.grey1} !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const StyledRadio = styled(Radio)`
  color: ${colors.primary};
  padding: 0;
  margin: 0;
  width: 16px;
  height: 16px;
  &.Mui-checked {
    color: ${colors.primary};
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 44px;
  background: ${colors.primary};
  border-radius: 8px;
  border: none;
  color: #ffffff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StyledCheckBox = styled(Checkbox)`
  color: ${colors.primary};
  padding: 0;
  margin: 0;
  &.Mui-checked {
    color: ${colors.primary};
  }
`;

export const StyledDropdown = styled(Select)`
  width: 100%;
  min-width: 140px;
  height: 44px;
  border-radius: 8px;
  label {
    display: none;
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }

  .MuiOutlinedInput-input {
    padding: 0 12px;
  }

  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: #f2f4f8;
    input {
      color: ${colors.grey1};
    }
  }
  .MuiInputBase-root.Mui-disabled {
    background-color: #f2f4f8 !important;
    input {
      color: ${colors.grey1} !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const StyledTableCellHeader = styled(TableCell)`
  border-bottom: none !important;
  padding: 6px 8px 6px 8px !important;
  position: sticky;
  top: 0;
  background-color: #f2f4f8;
  z-index: 2;
`;

export const StyledTableCellBody = styled(TableCell)<{ borderColor?: string }>`
  border-bottom: none !important;
  padding: 8px !important;
  vertical-align: middle !important;
  position: relative;

  ${({ borderColor }) =>
    borderColor
      ? `
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: ${borderColor};
    }
  `
      : ""}
`;

export const HoverTableRow = styled(TableRow)<{ $hoverColor?: string }>`
  td {
    transition: background-color 0.2s ease;
    vertical-align: middle !important;
  }

  &:hover td {
    background-color: ${({ $hoverColor }) => $hoverColor || "#f8f9fb"};
  }
`;

export const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 20px;
  margin-top: 16px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  flex-wrap: wrap;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  color: ${colors.grey1};
`;

export const LegendDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
`;

export const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background-color: #ffffff;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  color: ${colors.grey1};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background-color: #f2f4f8;
    border-color: ${colors.primary};
    color: ${colors.primary};
  }
`;

export const LegendActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const ExpandArrow = styled.div<{ isExpanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  color: ${colors.grey3};

  &:hover {
    background-color: #eaefff;
    color: ${colors.primary};
  }

  svg {
    transition: transform 0.25s ease;
    transform: ${({ isExpanded }) =>
      isExpanded ? "rotate(0deg)" : "rotate(-90deg)"};
  }
`;

export const SubRowHeaderCell = styled(TableCell)<{ borderColor?: string }>`
  border-bottom: 1px solid #e0e0e0 !important;
  padding: 10px 12px !important;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  color: ${colors.grey3};
  background-color: #f8f9fb;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  position: relative;

  ${({ borderColor }) =>
    borderColor
      ? `
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: ${borderColor};
    }
  `
      : ""}
`;

export const SubRowCell = styled(TableCell)<{ borderColor?: string }>`
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 10px 12px !important;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  color: ${colors.grey1};
  background-color: #fcfcfd;
  position: relative;

  ${({ borderColor }) =>
    borderColor
      ? `
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: ${borderColor};
    }
  `
      : ""}
`;

export const ParcelaName = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.grey1};
  white-space: nowrap;
`;

export const AvisoTag = styled.div<{ corAviso?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  color: ${({ corAviso }) => corAviso || colors.grey3};
  background-color: ${({ corAviso }) => {
    if (!corAviso) return "transparent";
    if (corAviso.includes("ed6c02") || corAviso.includes("ED6C02"))
      return "#FFF4E5";
    if (
      corAviso.includes("f43636") ||
      corAviso.includes("F43636") ||
      corAviso.includes("d32f2f") ||
      corAviso.includes("D32F2F")
    )
      return "#FFF0F0";
    if (corAviso.includes("4caf50") || corAviso.includes("4CAF50"))
      return "#E8F5E9";
    return "#F5F5F5";
  }};
  white-space: nowrap;
`;

export const PreviewOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 88px;
  padding: 20px 28px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #ffffff;
`;

export const PreviewTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const PreviewIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: ${colors.primary};
  box-shadow: 0 8px 18px rgba(45, 91, 255, 0.22);
`;

export const PreviewTitle = styled.h2`
  margin: 0;
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
`;

export const PreviewSubtitle = styled.p`
  margin: 4px 0 0;
  font-family: Inter;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #64748b;
  text-transform: uppercase;
`;

export const PreviewCloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  background-color: #ffffff;
  cursor: pointer;

  &:hover {
    color: #111827;
    border-color: #111827;
    background-color: #f8fafc;
  }
`;

export const PreviewContent = styled.div`
  flex: 1;
  overflow: auto;
  padding: 28px;
  background-color: #ffffff;
`;

export const PreviewSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;
  padding: 22px 28px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #f8fafc;
`;

export const PreviewSummaryValues = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
`;

export const PreviewSummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & + & {
    padding-left: 28px;
    border-left: 1px solid #dbe1ea;
  }

  span {
    font-family: Inter;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #64748b;
    text-transform: uppercase;
  }

  strong {
    font-family: Inter;
    font-size: 18px;
    font-weight: 800;
    color: #111827;
  }
`;

export const PreviewLegend = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;

  > span {
    font-family: Inter;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #94a3b8;
    text-transform: uppercase;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
`;

export const PreviewTableWrapper = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: auto;
`;

export const PreviewTable = styled.table`
  width: 100%;
  min-width: 1180px;
  border-collapse: collapse;
  font-family: Inter;

  thead {
    background-color: #111827;
  }

  th {
    padding: 16px 20px;
    font-size: 11px;
    font-weight: 800;
    color: #ffffff;
    text-align: left;
    text-transform: uppercase;
  }

  th:nth-child(3),
  td:nth-child(3) {
    text-align: center;
  }

  th:nth-child(4),
  th:nth-child(5),
  th:nth-child(6),
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6) {
    text-align: right;
  }

  td {
    padding: 15px 20px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 14px;
    color: #111827;
  }
`;

export const PreviewMainRow = styled.tr`
  background-color: #f8fafc;

  td {
    font-weight: 800;
  }
`;

export const PreviewSubRow = styled.tr`
  background-color: #ffffff;

  td {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 13px;
    font-weight: 600;
    color: #5f718b;
  }

  td:first-child {
    padding-left: 44px;
  }
`;

export const PreviewParcelaName = styled.span<{ $color: string }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 28px;

  &::before {
    content: "";
    position: absolute;
    left: -20px;
    top: -15px;
    bottom: -15px;
    width: 5px;
    background-color: ${({ $color }) => $color};
  }
`;

export const PreviewBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
  background-color: #e9eef5;
`;
